import moment from 'moment-timezone';

import useUser from './useUser';

const useTimezone = () => {
  const user = useUser();
  return user?.provider?.timezone || moment.tz.guess();
};

export default useTimezone;